export default __webpack_public_path__ + "static/media/nail-clippers.43a8e9d8.png";